<template>
  <div class="w-64">
    <TextField
      class="mb-4 text-sm"
      type="text"
      v-model="form.name"
      placeholder="Name"
      @keyup.stop.prevent.esc="closeNewShortlistForm"
      @keydown.stop.prevent.esc="closeNewShortlistForm"
      @keyup.native.enter="save"
      focus-on-mount
      size="sm"
      :errors="(errors.name || [])"
    />
    <div>
      <Button @click="save" size="sm" class="w-16">Add</Button>
      <Button @click="cancel" size="sm" class="w-16">Cancel</Button>
    </div>
  </div>
</template>

<script>
import { ref, inject } from '@vue/composition-api'
import Button from 'components/common/Button'
import TextField from 'components/forms/TextField'
import { ShortistContextSymbol } from '@/contexts/ShortlistContext'

export default {
  components: {
    Button,
    TextField,
  },
  props: {
    organizationId: String,
  },
  setup(props, { emit }) {
    const { fetchShortlists, createShortlist, errors } = inject(
      ShortistContextSymbol,
    )

    const getInitialData = () => ({
      name: '',
    })
    const form = ref(getInitialData())

    const save = async () => {
      console.log(' => save()', form.value)
      const { name } = form.value
      const data = { name }
      if (props.organizationId) {
        data.organizationId = props.organizationId
      }
      const response = await createShortlist(data)
      await fetchShortlists()
      emit('create', response.data)
    }
    const cancel = () => {
      emit('cancel')
    }

    return {
      form,
      errors,

      save,
      cancel,
    }
  },
}
</script>
